import React, { lazy } from "react";
import { Route, Switch } from "react-router-dom";

import Error404 from "modules/core/pages/Error404";

import { insightsPublicRoutesConstants as routesConstants } from "./routesConstants";

import { componentLazyImport } from "modules/core/utils/helpers";

const PublicRoadmap = lazy(() =>
  componentLazyImport(() => import("../../pages/PublicRoadmap"))
);

const InsightsPublicRoutes: React.FC = () => {
  return (
    <Switch>
      <Route path={routesConstants.roadmap.path}>
        <PublicRoadmap />
      </Route>

      <Route>
        <Error404 />
      </Route>
    </Switch>
  );
};

export default InsightsPublicRoutes;
